<template>
  <div>
    <Breadcrumbs
      :paths="['/' + get_prefix() + 'group', $route.path]"
    ></Breadcrumbs>
    <v-toolbar>
      <v-toolbar-title>
        {{ $t("message.common.group") }}{{ $t("message.common.any_regist") }}
      </v-toolbar-title>
    </v-toolbar>
    <v-card class="pa-5 mt-1">
      <v-text-field
        :label="$t('message.common.group') + $t('message.common.any_name')"
        v-model="parameters.name"
        :rules="[
          v => (v && v.length <= 40) || $t('message.common.over_text', { length: 40 })
        ]"
        counter="40"
      >
      </v-text-field>
      <p class="text-right mt-5 mb-0">
        <v-btn
          color="primary"
          :disabled="!registable || executing"
          @click="regist_data(get_prefix() + 'group', '', 'group')"
        >
          {{ $t("message.common.regist") }}
        </v-btn>
        <v-btn :to="get_prev(get_prefix() + 'group')">
          {{ $t("message.common.prev") }}
        </v-btn>
      </p>
    </v-card>
  </div>
</template>

<script>
import Breadcrumbs from '../components/Breadcrumbs';
import { res_regist } from "../js/res_regist";
import { http_error } from "../js/http_error";

export default {
  name: 'group_regist',
  components: {
    Breadcrumbs
  },
  mixins: [res_regist, http_error],
  props: {
    mode: String
  },
  data: function(){
    return {
      module_id: "33",
      nav_path: null,
      executing: false,
      parameters: {
        name: ""
      }
    }
  },
  computed: {
    registable: function(){
      return this.parameters.name !== "" && this.parameters.name.length <= 40;
    }
  }
}
</script>
